import React, {useCallback, useEffect, useState} from "react";
import {DialogActions, DialogContent, DialogTitle, Divider} from "@mui/material";
import useIsMounted from "../../../hooks/use-is-mounted";
import Dialog from "../../base/dialog";
import Button from "../../base/button/button";
import Api from "../../../../core/services/api/api";
import CustomerAutocomplete from "../../text-fields/autocomplete/customer-autocomplete";
import {Row} from "reactstrap";

const AssignCustomerToGiftCardDialog = ({
                                            open,
                                            setOpen,
                                            onSuccess,
                                            giftCard,
                                        }) => {
    const [customer, setCustomer] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const isMounted = useIsMounted();

    /**
     * Resets the customer when the dialog is opened.
     */
    useEffect(() => {
        if (open) {
            setCustomer(null);
        }
    }, [open]);

    /**
     * Assigns the customer to the gift card and if the result of the api is successful, then
     * navigates the operator back to gift cards page.
     * @param customer {any}
     */
    const assignCustomerToGiftCard = useCallback(async (customer) => {
        setSubmitting(true);
        const forApi = {
            id: giftCard.id,
            lockForCustomer: customer.id,
        };
        const response = await Api.assignUserToGiftCard(forApi);
        if (!isMounted())
            return;
        setSubmitting(false);
        if (response?.resultFlag) {
            onSuccess({...giftCard, ...response.data});
            setOpen(false);
        }
    }, [giftCard, isMounted, onSuccess, setOpen]);


    return (
        <Dialog
            open={open}
            setOpen={setOpen}
            loading={submitting}
            disableEscapeKeyDown={submitting}
            disableBackdropClick={submitting}
            maxWidth={'md'}
            className={'bound-dialog'}
        >
            <DialogTitle className={''} id="scroll-dialog-title">
                <p className={`text-lg text-color-1 my-4 font-weight-semi-bold text-center`}>
                    Assign Customer to Gift Card
                </p>
                <Divider className='divider'/>
            </DialogTitle>
            <DialogContent className={'p-4'}>
                <div className=' w-100'>
                    <div className='mt-3 w-100'>
                        <p className='text-sm text-color-1'>
                            Please Select the customer you would like to assign to the selected gift card
                        </p>
                    </div>
                    <div className='my-3 w-100'/>
                    <CustomerAutocomplete
                        disabled={submitting}
                        value={customer}
                        onChange={(_, customer) => setCustomer(customer)}
                        label={'Customer'}
                    />
                    <div className='w-100 my-3'/>
                </div>
            </DialogContent>
            <DialogActions className={'p-0'}>
                <Row className={'w-100 no-gutters'}>
                    <Divider className='divider'/>
                    <Row className='no-gutters justify-content-between align-items-start w-100'>
                        <Button
                            disabled={submitting}
                            variant={'dialog'}
                            color={'primary'}
                            onClick={() => setOpen(false)}
                            borderRadius={'0 8px 0 8px'}
                        >
                            Close
                        </Button>
                        <Button
                            disabled={submitting || !customer}
                            variant={'dialog'}
                            color={'primary'}
                            onClick={() => assignCustomerToGiftCard(customer)}
                            type={'submit'}
                            borderRadius={'8px 0 8px 0'}
                        >
                            {
                                submitting
                                    ? "Submitting..."
                                    : "Submit"
                            }
                        </Button>
                    </Row>
                </Row>
            </DialogActions>
        </Dialog>
    );
}


export default AssignCustomerToGiftCardDialog;
